import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ErrorBoundary, LanguageSwitch } from '@/components';

// Shared layout of every logged-out page, so the language switch is placed once
function AuthLayout() {
  return (
    <ErrorBoundary>
      {/* Full-height page: stacks switch and card on phones, centres the card */}
      <div className="full-screen bg-background relative flex flex-col items-center justify-center p-4">
        {/* In the flow above the card on phones, pinned top-right from sm up so it covers nothing */}
        <div className="z-10 flex w-full max-w-md justify-end pb-2 sm:absolute sm:top-4 sm:right-4 sm:w-auto sm:p-0">
          <LanguageSwitch />
        </div>
        <Outlet />
      </div>
    </ErrorBoundary>
  );
}

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
});
